import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Autumn/Shape/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Shape',
  field: 'Geometry',
  weeks: [10, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/1Recognise2DAnd3DShapes" */ './1Recognise2DAnd3DShapes'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/2CountSidesOn2DShapes" */ './2CountSidesOn2DShapes'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/3CountVerticesOn2DShapes" */ './3CountVerticesOn2DShapes'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year2/Autumn/Shape/4Draw2DShapes" */ './4Draw2DShapes')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/5LinesOfSymmetryOnShapes" */ './5LinesOfSymmetryOnShapes'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/6UseLinesOfSymmetryToCompleteShapes" */ './6UseLinesOfSymmetryToCompleteShapes'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(/* webpackChunkName: "Year2/Autumn/Shape/7Sort2DShapes" */ './7Sort2DShapes')
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/8CountFacesOn3DShapes" */ './8CountFacesOn3DShapes'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/9CountEdgesOn3DShapes" */ './9CountEdgesOn3DShapes'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/10CountVerticesOn3DShapes" */ './10CountVerticesOn3DShapes'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(/* webpackChunkName: "Year2/Autumn/Shape/11Sort3DShapes" */ './11Sort3DShapes')
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/Shape/12MakePatternsWith2DAnd3DShapes" */ './12MakePatternsWith2DAnd3DShapes'
        )
    })
  ]
});
export default Block;
